import { render, staticRenderFns } from "./ProductAvailability.vue?vue&type=template&id=16fd76ec&scoped=true&"
import script from "./ProductAvailability.vue?vue&type=script&lang=js&"
export * from "./ProductAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd76ec",
  null
  
)

export default component.exports